import axios from "axios";

export const BASE_URL = import.meta.env.VITE_BASE_URL;

export const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const URL = {
  MASTER_ACC: "/acc",
  MASTER_DEALER: "/api/dealer",
  MASTER_ANGGOTA: "/anggota",

  TRX_INHOUSE: "/trx-inhouse",
  NERACA_SALDO: "/report/neraca-saldo",
  BUKU_BESAR: "/report/buku-besar",
};
